// extracted by mini-css-extract-plugin
module.exports = {"reminder":"AddToCalendarButton_reminder__GUMIu"};